import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { bootstrapMobileToken } from '@core/utils/AuthUtils';
import MobileLoading from './components/MobileLoading';

bootstrapMobileToken();

const App = React.lazy(() => import('./App'));

const container = document.getElementById('root');
const app = React.createElement(
  Suspense,
  {
    fallback: React.createElement(MobileLoading),
  },
  React.createElement(App),
);

if (container) {
  ReactDOM.render(app, container);
}
